import React from "react";
import { Loader2, X } from "lucide-react";

export function fmtDate(iso) {
    if (!iso) return "—";
    try {
        return new Date(iso).toLocaleDateString(undefined, {
            year: "numeric",
            month: "short",
            day: "numeric",
        });
    } catch {
        return "—";
    }
}

export function ActionDialog({ open, title, onClose, onConfirm, busy, children, confirmLabel, confirmIcon: Icon, confirmTone }) {
    if (!open) return null;
    const tone = confirmTone || "blue";
    const toneCls =
        tone === "red"
            ? "bg-red-600 hover:bg-red-500"
            : tone === "green"
              ? "bg-emerald-600 hover:bg-emerald-500"
              : "bg-[#007AFF] hover:bg-[#3395FF]";
    return (
        <div
            className="fixed inset-0 z-[120] flex items-center justify-center p-4 bg-black/70"
            onClick={onClose}
            data-testid="user-sub-action-overlay"
        >
            <div
                className="w-full max-w-md bg-[#0F1B3A] border border-[#2A3655] rounded-md shadow-2xl overflow-hidden"
                onClick={(e) => e.stopPropagation()}
            >
                <div className="px-5 py-3 border-b border-[#2A3655] bg-[#0A1128] flex items-center justify-between">
                    <h3 className="text-sm font-bold uppercase tracking-wider text-white">
                        {title}
                    </h3>
                    <button
                        type="button"
                        onClick={onClose}
                        className="text-slate-400 hover:text-white"
                    >
                        <X className="w-4 h-4" />
                    </button>
                </div>
                <div className="p-5 space-y-3">{children}</div>
                <div className="flex items-center justify-end gap-2 px-5 py-3 border-t border-[#2A3655] bg-[#0A1128]">
                    <button
                        type="button"
                        onClick={onClose}
                        data-testid="user-sub-action-cancel"
                        className="px-4 py-1.5 text-xs uppercase tracking-wider font-bold rounded-sm border border-[#2A3655] text-slate-300 hover:text-white"
                    >
                        Cancel
                    </button>
                    <button
                        type="button"
                        onClick={onConfirm}
                        disabled={busy}
                        data-testid="user-sub-action-confirm"
                        className={`px-4 py-1.5 text-xs uppercase tracking-wider font-bold rounded-sm text-white inline-flex items-center gap-1.5 disabled:opacity-50 ${toneCls}`}
                    >
                        {busy ? (
                            <Loader2 className="w-3 h-3 animate-spin" />
                        ) : Icon ? (
                            <Icon className="w-3 h-3" />
                        ) : null}
                        {confirmLabel || "Confirm"}
                    </button>
                </div>
            </div>
        </div>
    );
}

